import * as CONSTANTS from 'constants';

const INIT_STATE = {
    userWizardResponses: {}
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CONSTANTS.SET_USER_WIZARD_RESPONSES: {
            return {
                ...state,
                userWizardResponses: action.payload
            };
        }
        default:
            return state;
    }
};
